import { render, staticRenderFns } from "./MappingSelectedFields.vue?vue&type=template&id=031da13e&"
import script from "./MappingSelectedFields.vue?vue&type=script&lang=ts&"
export * from "./MappingSelectedFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports